import { Modal } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useScript } from 'usehooks-ts';
import LazyModal, { LazyModalComponentProps } from '../../../ui/components/lazy-modal';
import { closeModal } from '../../../ui/store/ui-slice';
import { signRequestsApi } from '../../api/sign-requests-api';
import { signRequestInPortalModalId } from '../../constants/constants';
import styles from './sign-request-in-portal-modal.module.css';

interface Props {
  iframeUrl?: string;
}

const SignRequestInPortalModalContent = ({
  isOpen,
  afterClose,
  iframeUrl,
}: LazyModalComponentProps & Props): JSX.Element => {
  const dispatch = useDispatch();
  const [sonTSDKInstance, setSonTSDKInstance] = useState<SonTSDK.SonTSDK>();

  const sonTSDKStatus = useScript(`https://js.signontab.com/sont-sdk.js`, {
    removeOnUnmount: false,
  });

  const close = () => {
    dispatch(closeModal(signRequestInPortalModalId));
    dispatch(signRequestsApi.util.invalidateTags(['SignRequests', 'Request']));
  };

  const iframeRefCallback = useCallback(
    (iframeRef: HTMLIFrameElement) => {
      if (iframeRef === null || sonTSDKInstance || sonTSDKStatus !== 'ready') {
        return;
      }

      const instance = new SonTSDK.SonTSDK(iframeRef, {
        canceled: () => {
          setTimeout(() => {
            close();
          }, 2000);
        },
        finished: () => {
          close();
        },
      });

      setSonTSDKInstance(instance);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [sonTSDKStatus],
  );

  useEffect(() => {
    if (sonTSDKInstance) {
      sonTSDKInstance.listen();

      return () => {
        sonTSDKInstance.clear();
      };
    }
  }, [sonTSDKInstance]);

  return (
    <Modal className={styles.modal} closable={false} open={isOpen} afterClose={afterClose} width={960} footer={false}>
      <iframe ref={iframeRefCallback} src={iframeUrl} className={styles.iframe} allow="geolocation; camera;" />
    </Modal>
  );
};

const SignRequestInPortalModal = (): JSX.Element => {
  return <LazyModal modalId={signRequestInPortalModalId} Component={SignRequestInPortalModalContent} />;
};

export default SignRequestInPortalModal;
